


































import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class Footer extends Vue {
    private currentYear: number = new Date().getFullYear()
    private company: string = 'EG'
    private companyLink: string = 'https://github.com/Eternal-Grace'
    private facebook: string = 'https://www.facebook.com/ParisPersonalTrainerOfficial'
    private instagram: string = 'https://instagram.com/parispersonaltrainer_official'

    get madeBy(): string {
        return this.$t('footer.site_made_by') + ' ' + this.company
    }
}
